import { MessageCircle } from 'lucide-react';
import { cn } from '@/shared/cn';
import { useChat } from './ChatContext';

/** `compact` draws the icon only (a header crowded with controls); the label
 *  stays as the button's accessible name and tooltip. */
export function AskAssistant({
  threadId,
  label,
  compact = false,
}: {
  threadId: string;
  label: string;
  compact?: boolean;
}) {
  const { selectThread, openRail } = useChat();

  return (
    <button
      type="button"
      onClick={() => {
        selectThread(threadId);
        openRail();
      }}
      aria-label={compact ? label : undefined}
      title={compact ? label : undefined}
      className={cn(
        'inline-flex items-center gap-1.5 text-xs font-medium text-muted underline-offset-4 transition-colors hover:text-accent-700 hover:underline dark:hover:text-accent-400',
        compact &&
          'size-[30px] justify-center rounded-[10px] border border-[var(--hairline-strong)] bg-[var(--surface-2)] hover:no-underline',
      )}
    >
      <MessageCircle size={14} aria-hidden="true" />
      {compact ? null : label}
    </button>
  );
}
